<template>
    <div ref="map" class="map" />
</template>

<script lang="ts">
    import {Component, mixins, Prop, Watch} from 'vue-facing-decorator'
    import gmapsInit from '~/utils/gmaps'
    import {HotelMapMixin} from '~src/components/hotels/mixins/hotelMapMixin.src'

    @Component({})
    export class OrderDetailsMap extends mixins(HotelMapMixin) {
        @Prop({default: null}) markerCoordinates
        @Prop({required: true, type: Array}) destinations
        @Prop({required: true, type: Array}) destinationLocations

        google = null
        map = null
        markers = []
        bounds = null
        destinationsPath = null

        @Watch('destinationLocations', {deep: true, immediate: true})
        onDestinationsChange() {
            if (!this.map) return
            this.initMarkers()
        }

        @Watch('markerCoordinates.length')
        onMarkersChange() {
            if (!this.map) return
            this.initMarkers()
        }

        async mounted() {
            await this.$store.restored
            await this.load()
        }

        async load() {
            try {
                this.google = await gmapsInit()
                this.map = new this.google.maps.Map(this.$refs.map, {
                    disableDefaultUI: true,
                    gestureHandling: 'greedy',
                    fullscreenControl: true,
                    zoom: 6,
                })
                if (this.markerCoordinates.length || this.destinationLocations.length) this.initMarkers()
            } catch (error) {
                console.error(error)
            }
        }

        initMarkers() {
            if (this.markers.length) this.markers.forEach(marker => marker.setMap(null))
            this.markerCoordinates.forEach(e => {
                this.addMarker(e)
            })
            if (this.destinations.length && this.destinationLocations.length) {
                if (this.destinationsPath) this.destinationsPath.setMap(null)
                const destinationMarkers = []
                const cityIds = []
                const uniqueDestinations = this.destinations.reduce((uniqueDestinations, destination) => {
                    if (!cityIds.includes(destination.cityId)) {
                        uniqueDestinations.push(destination)
                        cityIds.push(destination.cityId)
                    }
                    return uniqueDestinations
                }, [])
                uniqueDestinations.forEach((destination, index) => {
                    const {latitude, longitude} = this.destinationLocations.find(({id}) => id === destination.cityId)
                    const destinationMarker = this.addMarker({
                        type: 'destination',
                        index,
                        lat: latitude,
                        lng: longitude,
                    })
                    destinationMarkers.push(destinationMarker)
                })
                this.destinationsPath = new this.google.maps.Polyline({
                    path: destinationMarkers.map(el => el.getPosition()),
                    geodesic: true,
                    strokeColor: '#FF0000',
                    strokeOpacity: 1.0,
                    strokeWeight: 2,
                })
                this.destinationsPath.setMap(this.map)
            }

            this.bounds = new this.google.maps.LatLngBounds()
            this.markers.forEach(marker => this.bounds.extend(marker.getPosition()))
            if (this.markers.length > 1) {
                this.map.fitBounds(this.bounds)
            } else {
                this.map.setZoom(8)
                this.map.setCenter(this.markers[0].position)
            }
        }

        addMarker(data) {
            const label = {
                color: '#ffffff',
                fontSize: '18px',
            }
            if (data.type === 'activity') {
                Object.assign(label, {
                    text: '󱐌',
                    fontFamily: '"Material Design Icons',
                })
            } else if (data.type === 'hotel') {
                Object.assign(label, {
                    text: '󰦑',
                    fontFamily: '"Material Design Icons',
                })
            } else if (data.type === 'destination') {
                label.text = data.index + 1 + ''
            }
            const marker = new this.google.maps.Marker({
                position: {
                    lat: data.lat,
                    lng: data.lng,
                },
                map: this.map,
                label,
            })
            this.markers.push(marker)
            return marker
        }
    }

    export default OrderDetailsMap
</script>

<style scoped lang="scss">
    .map {
        height: 280px;
        z-index: 1;
    }
</style>
